<template>
  <div class="g-page">
    <div class="content-container">

      <!-- HEADER -->
      <div class="header-row mb-4">
        <div class="d-flex align-items-center">
          <button class="back-circle-btn mr-3" @click="$router.push({ path: '/malumot/user/index' })" type="button">
            <b-icon icon="chevron-left"></b-icon>
          </button>
          <h2 class="page-title">
            {{ $route.params.id ? $t('Foydalanuvchini tahrirlash') : $t('Yangi foydalanuvchi') }}
          </h2>
        </div>
        <div class="header-actions">
          <button class="btn-cancel mr-2" @click="$router.push({ path: '/malumot/user/index' })" type="button">
            {{ $t("Bekor qilish") }} <sup>esc</sup>
          </button>
          <button class="btn-save" @click="Savedokument" type="button">
            <b-icon icon="check-all" class="mr-1"></b-icon>
            {{ $t("Saqlash") }} <sup>ctrl+enter</sup>
          </button>
        </div>
      </div>

      <!-- ASOSIY FORMA -->
      <div class="modern-card">
        <div class="row custom-gutter">

          <!-- Chap tomon: Shaxsiy ma'lumotlar -->
          <div class="col-md-5 section-divider">
            <div class="section-header">
              <b-icon icon="person-lines-fill"></b-icon>
              <span>{{ $t("Shaxsiy ma'lumotlar") }}</span>
            </div>

            <div class="form-unit">
              <label>{{ $t("Ismi") }}</label>
              <input v-model="datas.first_name" type="text" :placeholder="$t('Kiriting...')" ref="focused">
            </div>

            <div class="form-unit">
              <label>{{ $t("Familiya") }}</label>
              <input v-model="datas.last_name" type="text" :placeholder="$t('Kiriting...')">
            </div>

            <div class="form-unit">
              <label>
                {{ $t("Pochta") }}
                <small style="font-weight:500;color:#94a3b8;text-transform:none;letter-spacing:0">(ixtiyoriy)</small>
              </label>
              <input v-model="datas.email" type="email" placeholder="example@mail.com (ixtiyoriy)">
            </div>

            <div class="row">
              <div class="col-6">
                <div class="form-unit">
                  <label>{{ $t("Sklad") }}</label>
                  <v-select
                    :disabled="skladhave"
                    :clearable="false"
                    class="modern-vselect"
                    :options="skladlist"
                    v-model="datas.sklad_id"
                    :reduce="name => name.id"
                    label="name"
                    :placeholder="$t('Tanlang')"
                  >
                    <template #search="{attributes, events}">
                      <input class="vs__search" v-bind="attributes" v-on="events" />
                    </template>
                    <template #selected-option="{ name }">{{ name }}</template>
                    <template v-slot:no-options="{ search, searching }">
                      <template v-if="searching">
                        <em><b>{{ search }}</b></em> {{ $t("бўйича маьлумот йўқ") }}
                      </template>
                      <em style="opacity: 0.5;" v-else>{{ $t("Маьлумот йўқ") }}</em>
                    </template>
                  </v-select>
                </div>
              </div>
              <div class="col-6">
                <div class="form-unit">
                  <label>{{ $t("Xodim") }}</label>
                  <v-select
                    :clearable="false"
                    class="modern-vselect"
                    :options="stafflist"
                    v-model="datas.staff_id"
                    :reduce="name => name.id"
                    label="name"
                    :placeholder="$t('Tanlang')"
                  >
                    <template v-slot:no-options="{ search, searching }">
                      <template v-if="searching">
                        <em><b>{{ search }}</b></em> {{ $t("бўйича маьлумот йўқ") }}
                      </template>
                      <em style="opacity: 0.5;" v-else>{{ $t("Маьлумот йўқ") }}</em>
                    </template>
                  </v-select>
                </div>
              </div>
            </div>

            <!-- ROL TANLASH -->
            <div class="section-header mt-3">
              <b-icon icon="person-badge"></b-icon>
              <span>{{ $t("Rol (Lavozim)") }}</span>
            </div>
            <div class="form-unit">
              <div class="role-toggle">
                <label class="role-option" :class="{ active: datas.role === 'Admin' }">
                  <input type="radio" value="Admin" v-model="datas.role" @change="onRoleChange" />
                  <span class="ro-icon">👑</span>
                  <div class="ro-info">
                    <strong>Admin</strong>
                    <small>To'liq huquq</small>
                  </div>
                </label>
                <label class="role-option" :class="{ active: datas.role === 'SuperUser' }">
                  <input type="radio" value="SuperUser" v-model="datas.role" @change="onRoleChange" />
                  <span class="ro-icon">🛒</span>
                  <div class="ro-info">
                    <strong>Sotuvchi</strong>
                    <small>O'chirishdan boshqa hammasi</small>
                  </div>
                </label>
                <label class="role-option" :class="{ active: datas.role === 'MainSklad' }">
                  <input type="radio" value="MainSklad" v-model="datas.role" @change="onRoleChange" />
                  <span class="ro-icon">📦</span>
                  <div class="ro-info">
                    <strong>Omborchi</strong>
                    <small>Sklad va kirim</small>
                  </div>
                </label>
              </div>
            </div>

            <div class="section-header mt-3">
              <b-icon icon="cash-stack"></b-icon>
              <span>{{ $t("Oylik va Bonus") }}</span>
            </div>

            <!-- Salary type chooser -->
            <div class="form-unit">
              <label>{{ $t("Oylik turi") }}</label>
              <div class="salary-type-toggle">
                <label class="st-option" :class="{ active: (datas.salary_type || 'kunlik') === 'kunlik' }">
                  <input type="radio" value="kunlik" v-model="datas.salary_type" />
                  <span class="st-icon">📅</span>
                  <div class="st-info">
                    <strong>Kunlik</strong>
                    <small>Har kun uchun oylik (1 kunlik)</small>
                  </div>
                </label>
                <label class="st-option" :class="{ active: datas.salary_type === 'oylik' }">
                  <input type="radio" value="oylik" v-model="datas.salary_type" />
                  <span class="st-icon">🗓️</span>
                  <div class="st-info">
                    <strong>Oylik</strong>
                    <small>30 kunga (oylik) belgilanadi</small>
                  </div>
                </label>
              </div>
            </div>

            <div class="row">
              <div class="col-6">
                <div class="form-unit">
                  <label>
                    {{ (datas.salary_type === 'oylik' ? "Oylik summasi (30 kun)" : "Kunlik oylik summasi") }}
                    <span v-if="parseFloat(datas.salary) > 0" class="set-badge">
                      ✓ {{ formatMoney(datas.salary) }}
                    </span>
                  </label>
                  <input
                    v-model.number="datas.salary"
                    type="number"
                    min="0"
                    step="1000"
                    placeholder="0"
                    class="money-input"
                  >
                </div>
              </div>
              <div class="col-6">
                <div class="form-unit">
                  <label>
                    {{ $t("KPI bonus (%)") }}
                    <span v-if="parseFloat(datas.percent) > 0" class="set-badge bonus-badge">
                      ✓ {{ datas.percent }}%
                    </span>
                  </label>
                  <input
                    v-model.number="datas.percent"
                    type="number"
                    min="0"
                    max="100"
                    step="0.5"
                    placeholder="0"
                    class="money-input"
                  >
                </div>
              </div>
            </div>

            <div v-if="parseFloat(datas.salary) > 0 || parseFloat(datas.percent) > 0" class="salary-summary">
              <div class="summary-item" v-if="parseFloat(datas.salary) > 0">
                <span class="summary-label">{{ datas.salary_type === 'oylik' ? '1 kunga (30 kunlikdan)' : 'Oylik (30 kun)' }}:</span>
                <strong>{{ formatMoney(datas.salary_type === 'oylik' ? ((datas.salary || 0) / 30) : ((datas.salary || 0) * 30)) }}</strong>
              </div>
              <div class="summary-item" v-if="parseFloat(datas.percent) > 0">
                <span class="summary-label">KPI bonus:</span>
                <strong>Har savdoning {{ datas.percent }}% i</strong>
              </div>
            </div>

            <div class="section-header mt-3">
              <b-icon icon="shield-lock"></b-icon>
              <span>{{ $t("Kirish ma'lumotlari") }}</span>
            </div>

            <div class="form-unit">
              <label>{{ $t("Login") }}</label>
              <input v-model="datas.username" type="text" placeholder="login">
            </div>

            <div class="row">
              <div class="col-6">
                <div class="form-unit">
                  <label>{{ $t("Parol") }}</label>
                  <input v-model="datas.password" type="password" placeholder="••••••">
                </div>
              </div>
              <div class="col-6">
                <div class="form-unit">
                  <label>{{ $t("Parol tasdiqlash") }}</label>
                  <input v-model="datas.confirm_password" @change="Changeparol()" type="password" placeholder="••••••">
                </div>
              </div>
            </div>
          </div>

          <!-- O'ng tomon: Huquqlar jadvali -->
          <div class="col-md-7 pl-md-4">
            <div class="section-header">
              <b-icon icon="key"></b-icon>
              <span>{{ $t("Huquqlar") }}</span>
              <button type="button" class="btn-select-all" @click="Clickall()">
                {{ $t("Barchasini belgilash") }}
              </button>
            </div>

            <div class="rules-table-wrapper">
              <table class="rules-table">
                <thead>
                  <tr>
                    <th>{{ $t("Nomi") }}</th>
                    <th class="th-center">{{ $t("Ko'rish") }}</th>
                    <th class="th-center">{{ $t("Ochish") }}</th>
                    <th class="th-center">{{ $t("O'zgartirish") }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, idx) in flatMenuRows" :key="idx"
                      :class="{ 'rule-group-header': row.isGroup }">
                    <template v-if="row.isGroup">
                      <td colspan="4"><strong>{{ row.title }}</strong></td>
                    </template>
                    <template v-else>
                      <td>{{ row.name }}</td>
                      <td class="td-center"><input type="checkbox" v-model="menuRules[row.path].see" class="modern-checkbox"></td>
                      <td class="td-center"><input type="checkbox" v-model="menuRules[row.path].open" class="modern-checkbox"></td>
                      <td class="td-center"><input type="checkbox" v-model="menuRules[row.path].change" class="modern-checkbox"></td>
                    </template>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

        </div>
      </div>

      <!-- MOBIL ILOVA HUQUQLARI -->
      <div class="modern-card mt-4">
        <div class="section-header">
          <b-icon icon="phone"></b-icon>
          <span>{{ $t("Mobil ilova huquqlari") }} </span>
          <button type="button" class="btn-select-all" @click="ClickallMobile()">
            {{ $t("Barchasini belgilash") }}
          </button>
        </div>

        <div class="mobile-groups-grid">
          <div v-for="group in mobileMenuGroups" :key="group.key" class="mobile-group-card">
            <div class="mobile-group-title">
              <input
                type="checkbox"
                class="modern-checkbox mr-2"
                :checked="isGroupAllChecked(group)"
                @change="toggleGroup(group, $event.target.checked)"
              >
              {{ group.label }}
            </div>
            <div class="mobile-perm-list">
              <label
                v-for="perm in group.permissions"
                :key="perm.key"
                class="mobile-perm-item"
              >
                <input
                  type="checkbox"
                  class="modern-checkbox"
                  v-model="mobileMenuRules[perm.key]"
                >
                <span>{{ perm.label }}</span>
              </label>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>
<script>
import { print } from "../../../components/mixins/print.js";
import $ from "jquery";

// DashboardLayout.vue dagi menuga mos huquqlar ro'yxati
const MENU_GROUPS = [
  {
    title: 'SAVDO',
    items: [
      { name: "Savdolar ro'yxati", path: '/chiqim/index' },
      { name: 'Savdo (POS)', path: '/chiqim/pos' },
      { name: 'Zakazlar', path: '/zakazlar/index' },
      { name: 'Ombor (Qoldiq)', path: '/ombor' },
      { name: "Ta'minot (Kirim)", path: '/kirim/index' },
    ]
  },
  {
    title: 'MOLIYA',
    items: [
      { name: 'Xarajatlar', path: '/xarajatlar/index' },
      { name: 'Nasiyalar', path: '/nasiyalar' },
      { name: 'Ustalar', path: '/usta/index' },
    ]
  },
  {
    title: 'BOSHQARUV',
    items: [
      { name: 'Hisobot', path: '/xisobot/main' },
    ]
  },
  {
    title: "MA'LUMOTLAR",
    items: [
      { name: 'Paketlar', path: '/paket/index' },
      { name: 'Brendlar', path: '/brand/index' },
      { name: 'Tolov turlari', path: '/pay-type/index' },
      { name: 'Kurs', path: '/malumot/dollar/index' },
      { name: 'Modellar', path: '/model/index' },
      { name: 'Mijozlar', path: '/malumot/kontragent/index' },
      { name: "Ta'minotchilar", path: '/taminotchi/index' },
      { name: 'Maxsulotlar', path: '/directory/product/index' },
      // { name: 'Takliflar', path: '/offers' },
      // { name: 'Kontaktlar', path: '/contact' },
      { name: 'Skladlar', path: '/malumot/sklad/index' },
      { name: 'Foydalanuvchilar', path: '/malumot/user/index' },
    ]
  },
];

// Barcha path lardan bo'sh menu_json yaratish
function buildEmptyMenuJson() {
  const obj = {};
  for (const group of MENU_GROUPS) {
    for (const item of group.items) {
      obj[item.path] = { see: false, open: false, change: false };
    }
  }
  return obj;
}

// ===== MOBIL ILOVA (Flutter) HUQUQLARI =====
// Backend bilan sinxron: /api/v1/user/mobile-menu/catalog bilan bir xil kalitlar.
const MOBILE_GROUP_LABELS = {
  masters: 'Ustalar',
  clients: 'Mijozlar',
  suppliers: "Ta'minotchilar",
  debt: 'Qarzdorlik',
  reports: 'Hisobotlar',
  income: 'Kirim',
  expense: 'Xarajat',
  currency: 'Kurs',
  warehouse: 'Sklad',
  brand: 'Brend',
  model: 'Model',
  payment_type: "To'lov turlari",
  users: 'Foydalanuvchilar',
  service: 'Xizmatlar',
  sales: 'Savdo',
};

const MOBILE_ACTION_LABELS = {
  view: "Ko'rish",
  create: "Qo'shish",
  update: 'Tahrirlash',
  delete: "O'chirish",
  payment: "To'lov",
  manage: 'Boshqarish',
  pay: "To'lash",
  export: 'Eksport',
  transfer: "Ko'chirish",
  assign_role: 'Rol berish',
  refund: 'Qaytarish',
};

const MOBILE_PERMISSIONS = [
  { key: 'masters.view',    group: 'masters' },
  { key: 'masters.create',  group: 'masters' },
  { key: 'masters.delete',  group: 'masters' },
  { key: 'masters.payment', group: 'masters' },
  { key: 'clients.view',    group: 'clients' },
  { key: 'clients.create',  group: 'clients' },
  { key: 'clients.delete',  group: 'clients' },
  { key: 'clients.payment', group: 'clients' },
  { key: 'suppliers.view',    group: 'suppliers' },
  { key: 'suppliers.create',  group: 'suppliers' },
  { key: 'suppliers.delete',  group: 'suppliers' },
  { key: 'suppliers.payment', group: 'suppliers' },
  { key: 'debt.view',   group: 'debt' },
  { key: 'debt.manage', group: 'debt' },
  { key: 'debt.pay',    group: 'debt' },
  { key: 'reports.view',   group: 'reports' },
  { key: 'reports.export', group: 'reports' },
  { key: 'income.view',   group: 'income' },
  { key: 'income.create', group: 'income' },
  { key: 'income.delete', group: 'income' },
  { key: 'expense.view',   group: 'expense' },
  { key: 'expense.create', group: 'expense' },
  { key: 'expense.delete', group: 'expense' },
  { key: 'currency.view',   group: 'currency' },
  { key: 'currency.update', group: 'currency' },
  { key: 'warehouse.view',     group: 'warehouse' },
  { key: 'warehouse.update',   group: 'warehouse' },
  { key: 'warehouse.transfer', group: 'warehouse' },
  { key: 'brand.view',   group: 'brand' },
  { key: 'brand.create', group: 'brand' },
  { key: 'brand.delete', group: 'brand' },
  { key: 'model.view',   group: 'model' },
  { key: 'model.create', group: 'model' },
  { key: 'model.delete', group: 'model' },
  { key: 'payment_type.view',   group: 'payment_type' },
  { key: 'payment_type.create', group: 'payment_type' },
  { key: 'payment_type.delete', group: 'payment_type' },
  { key: 'users.view',        group: 'users' },
  { key: 'users.create',      group: 'users' },
  { key: 'users.update',      group: 'users' },
  { key: 'users.delete',      group: 'users' },
  { key: 'users.assign_role', group: 'users' },
  { key: 'service.view',   group: 'service' },
  { key: 'service.create', group: 'service' },
  { key: 'service.update', group: 'service' },
  { key: 'service.delete', group: 'service' },
  // Savdo — alohida ruxsatlar
  { key: 'sales.delete', group: 'sales' },
  { key: 'sales.refund', group: 'sales' },
];

function buildMobileGroups() {
  const map = {};
  for (const p of MOBILE_PERMISSIONS) {
    if (!map[p.group]) map[p.group] = { key: p.group, label: MOBILE_GROUP_LABELS[p.group] || p.group, permissions: [] };
    const action = p.key.split('.')[1] || p.key;
    map[p.group].permissions.push({ key: p.key, label: MOBILE_ACTION_LABELS[action] || action });
  }
  return Object.values(map);
}

function buildEmptyMobileRules() {
  const obj = {};
  for (const p of MOBILE_PERMISSIONS) obj[p.key] = false;
  return obj;
}

export default {
  name: "user-form",
  mixins: [print],
  data() {
    return {
      filter: "",
      skladlist: [],
      stafflist: [],
      menuGroups: MENU_GROUPS,
      menuRules: buildEmptyMenuJson(),
      mobileMenuGroups: buildMobileGroups(),
      mobileMenuRules: buildEmptyMobileRules(),
    };
  },
  props: ["datas"],
  computed: {
    flatMenuRows() {
      const rows = [];
      for (const group of this.menuGroups) {
        rows.push({ isGroup: true, title: group.title });
        for (const item of group.items) {
          rows.push({ isGroup: false, name: item.name, path: item.path });
        }
      }
      return rows;
    }
  },
  created() {
    let self = this;
    self.$root.$refs.user = self;
  },
  watch: {
    'datas.menu_json': {
      immediate: true,
      deep: true,
      handler(val) {
        // menu_json dan menuRules ga yuklash
        const base = buildEmptyMenuJson();
        if (val && typeof val === 'object') {
          for (const path in val) {
            if (base[path]) {
              base[path].see = !!val[path].see;
              base[path].open = !!val[path].open;
              base[path].change = !!val[path].change;
            }
          }
        }
        this.menuRules = base;
      }
    },
    'datas.mobile_menu': {
      immediate: true,
      deep: true,
      handler(val) {
        // mobile_menu ({ permissions: [{key, group}] } yoki array) → flat flaglarga aylantirish
        const base = buildEmptyMobileRules();
        let list = null;
        if (Array.isArray(val)) list = val;
        else if (val && Array.isArray(val.permissions)) list = val.permissions;
        if (list) {
          for (const item of list) {
            const key = typeof item === 'string' ? item : (item && item.key);
            if (key && key in base) base[key] = true;
          }
        }
        this.mobileMenuRules = base;
      }
    }
  },
  mounted: function() {
    this.Skladlist();
    this.Stafflist();
    this.Focus();
  },
  methods: {
    Clickall(){
      for (const path in this.menuRules) {
        this.menuRules[path].see = true;
        this.menuRules[path].open = true;
        this.menuRules[path].change = true;
      }
      // Vue 2 reactivity uchun
      this.menuRules = Object.assign({}, this.menuRules);
    },
    // Rol tanlanganda huquqlarni avto-belgilash:
    //   Admin     — barcha huquq
    //   Sotuvchi  — barchasi YOQILADI lekin o'chirish (.delete) BELGILANMAYDI
    //   Omborchi  — sklad/kirim/qoldiq bilan bog'liq huquqlar
    onRoleChange() {
      const role = this.datas.role;

      if (role === 'Admin') {
        // Hammasi yoqilsin
        for (const path in this.menuRules) {
          this.menuRules[path].see = true;
          this.menuRules[path].open = true;
          this.menuRules[path].change = true;
        }
        const next = {};
        for (const k in this.mobileMenuRules) next[k] = true;
        this.mobileMenuRules = next;
      }
      else if (role === 'SuperUser') {
        // Sotuvchi: hammasi yoqiladi, faqat .delete va .refund (xavfli amallar) belgilanmaydi.
        // Admin kerak bo'lsa qo'lda yoqib beradi (masalan sales.delete, sales.refund).
        for (const path in this.menuRules) {
          this.menuRules[path].see = true;
          this.menuRules[path].open = true;
          this.menuRules[path].change = true;
        }
        const next = {};
        for (const k in this.mobileMenuRules) {
          next[k] = !k.endsWith('.delete') && !k.endsWith('.refund');
        }
        this.mobileMenuRules = next;
      }
      else if (role === 'MainSklad') {
        // Omborchi: faqat sklad/kirim/qoldiq/mahsulot/brand/model
        const allowedWebPaths = [
          '/ombor', '/kirim/index', '/directory/product/index',
          '/brand/index', '/model/index',
          '/malumot/sklad/index', '/paket/index',
          '/taminotchi/index',
        ];
        for (const path in this.menuRules) {
          const allowed = allowedWebPaths.includes(path);
          this.menuRules[path].see = allowed;
          this.menuRules[path].open = allowed;
          this.menuRules[path].change = allowed;
        }
        const allowedMobileGroups = ['suppliers', 'income', 'warehouse', 'brand', 'model'];
        const next = {};
        for (const k in this.mobileMenuRules) {
          const groupKey = k.split('.')[0];
          const isDelete = k.endsWith('.delete');
          const isRefund = k.endsWith('.refund');
          next[k] = allowedMobileGroups.includes(groupKey) && !isDelete && !isRefund;
        }
        this.mobileMenuRules = next;
      }
      this.menuRules = Object.assign({}, this.menuRules);
    },
    ClickallMobile() {
      // Agar barchasi yoqilgan bo'lsa — hammasini o'chirish, aks holda hammasini yoqish
      const allOn = Object.values(this.mobileMenuRules).every(v => v);
      const next = {};
      for (const k in this.mobileMenuRules) next[k] = !allOn;
      this.mobileMenuRules = next;
    },
    isGroupAllChecked(group) {
      return group.permissions.every(p => this.mobileMenuRules[p.key]);
    },
    toggleGroup(group, checked) {
      const next = { ...this.mobileMenuRules };
      for (const p of group.permissions) next[p.key] = checked;
      this.mobileMenuRules = next;
    },
    Skladlist() {
      let self = this;
      axios.get("api/v1/sklads").then(function(response) {
        self.skladlist = response.data;
      });
    },
    Stafflist() {
      let self = this;
      axios.get("api/v1/staff").then(function(response) {
        self.stafflist = response.data;
      });
    },
    Changeparol() {
      if (this.datas.password != this.datas.confirm_password) {
        this.$store.state.errors = this.$t("Парол тасдиқланмади");
      }
    },
    Focus() {
      this.$refs.focused.focus();
    },
    formatMoney(n) {
      const v = parseFloat(n || 0);
      return v.toLocaleString('ru-RU', { maximumFractionDigits: 0 }) + " so'm";
    },
    Savedokument() {
      let self = this;
      if(self.rule.change==true){
        if (this.$route.path == "/malumot/user/create") {
          var methods = "post";
          var action = "api/v1/users";
        } else {
          var methods = "patch";
          var action = "api/v1/users/id/" + self.$route.params.id;
        }

        // menu_json ni datas ga qo'shish
        self.datas.menu_json = self.menuRules;
        // mobile_menu ni kanonik shaklga (permissions: [{key, group}]) aylantirib yuborish
        self.datas.mobile_menu = {
          permissions: MOBILE_PERMISSIONS
            .filter(p => self.mobileMenuRules[p.key])
            .map(p => ({ key: p.key, group: p.group })),
        };
        // sklad_id butun son bo'lishi kerak
        if (self.datas.sklad_id) {
          self.datas.sklad_id = parseInt(self.datas.sklad_id);
        }

        axios({
          method: methods,
          url: action,
          data: self.datas
        }).then(function(response) {
          self.$store.state.saved = 1;
          self.$router.push({ name: "Фойдаланувчи" });
        }).catch(function(error) {
          if (error.response && error.response.data) {
            self.$store.state.errors = error.response.data.message || "Xatolik yuz berdi";
          } else {
            self.$store.state.errors = "Serverga ulanishda xatolik";
          }
        });
      } else{
        self.$store.state.errors=self.$t('Sizdan bunday xuquq mavjud emas');
      }
    }
  }
};
</script>

<style scoped>
/* SAHIFA ASOSI */
.g-page {
  padding: 30px;
  background: #f4f7f9;
  height: calc(100vh - 56px);
  overflow-y: auto;
  overflow-x: hidden;
  box-sizing: border-box;
}
.g-page::-webkit-scrollbar {
  width: 10px;
}
.g-page::-webkit-scrollbar-track {
  background: transparent;
}
.g-page::-webkit-scrollbar-thumb {
  background: #d6c6f0;
  border-radius: 5px;
}
.g-page::-webkit-scrollbar-thumb:hover {
  background: #a142f4;
}

.content-container {
  max-width: 1300px;
  margin: 0 auto;
}

/* HEADER */
.header-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.page-title {
  font-weight: 800;
  font-size: 24px;
  color: #2c3e50;
  margin: 0;
}

.back-circle-btn {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 1px solid #e0e6ed;
  background: white;
  color: #7f8c8d;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.3s;
  cursor: pointer;
}

.back-circle-btn:hover {
  background: #a142f4;
  color: white;
  border-color: #a142f4;
}

/* TUGMALAR */
.btn-save {
  background: #a142f4;
  color: white;
  border: none;
  padding: 10px 25px;
  border-radius: 10px;
  font-weight: 700;
  box-shadow: 0 4px 12px rgba(161, 66, 244, 0.25);
  transition: 0.3s;
  cursor: pointer;
}

.btn-save:hover {
  background: #8e39d9;
  transform: translateY(-1px);
}

.btn-save sup {
  font-weight: 400;
  opacity: 0.7;
}

.btn-cancel {
  background: white;
  border: 1px solid #dcdde1;
  color: #7f8c8d;
  padding: 10px 20px;
  border-radius: 10px;
  font-weight: 600;
  cursor: pointer;
}

.btn-cancel sup {
  font-weight: 400;
  opacity: 0.6;
}

/* MODERN CARD */
.modern-card {
  background: white;
  border-radius: 24px;
  padding: 40px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.02);
  border: 1px solid #f1f2f6;
}

.section-divider {
  border-right: 1px solid #f1f2f6;
  padding-right: 30px;
}

.section-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 25px;
  color: #2c3e50;
  font-weight: 700;
  font-size: 16px;
}

.section-header svg {
  color: #a142f4;
}

/* FORM UNITS */
.form-unit {
  margin-bottom: 20px;
}

.form-unit label {
  display: block;
  font-size: 12px;
  font-weight: 700;
  color: #95a5a6;
  margin-bottom: 8px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.form-unit input[type="text"],
.form-unit input[type="email"],
.form-unit input[type="password"],
.form-unit input[type="number"] {
  width: 100%;
  background: #f8fafc;
  border: 1px solid #f8fafc;
  border-radius: 12px;
  padding: 12px 15px;
  color: #2c3e50;
  font-weight: 600;
  transition: 0.3s;
}

.form-unit input[type="text"]:focus,
.form-unit input[type="email"]:focus,
.form-unit input[type="password"]:focus,
.form-unit input[type="number"]:focus {
  background: white;
  border-color: #a142f4;
  outline: none;
  box-shadow: 0 0 0 4px rgba(161, 66, 244, 0.05);
}

/* OYLIK / BONUS */
.money-input {
  font-family: 'Inter', system-ui, sans-serif;
  font-size: 15px !important;
  letter-spacing: 0.3px;
}

/* SALARY TYPE TOGGLE */
.salary-type-toggle {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}

.st-option {
  display: flex;
  align-items: center;
  gap: 12px;
  background: #f8fafc;
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  padding: 12px 14px;
  cursor: pointer;
  transition: 0.2s;
  margin: 0;
}

.st-option:hover {
  border-color: #c4b5fd;
  background: #faf5ff;
}

.st-option.active {
  border-color: #a142f4;
  background: #faf5ff;
  box-shadow: 0 2px 10px rgba(161, 66, 244, 0.12);
}

.st-option input[type="radio"] {
  display: none;
}

.st-icon {
  font-size: 22px;
  flex-shrink: 0;
}

.st-info {
  flex: 1;
  min-width: 0;
}

.st-info strong {
  display: block;
  font-size: 14px;
  color: #1e293b;
  font-weight: 700;
  text-transform: none;
  letter-spacing: 0;
}

.st-info small {
  font-size: 11px;
  color: #94a3b8;
  font-weight: 500;
  text-transform: none;
  letter-spacing: 0;
}

.st-option.active .st-info strong { color: #a142f4; }

.set-badge {
  display: inline-block;
  background: #e6f7ee;
  color: #15803d;
  padding: 2px 8px;
  border-radius: 10px;
  font-size: 11px;
  font-weight: 700;
  margin-left: 6px;
  text-transform: none;
  letter-spacing: 0;
  vertical-align: middle;
}

/* ROLE TANLASH */
.role-toggle {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
}
.role-option {
  display: flex;
  align-items: center;
  gap: 8px;
  background: #f8fafc;
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  padding: 10px 12px;
  cursor: pointer;
  transition: 0.2s;
  margin: 0;
}
.role-option:hover { border-color: #c4b5fd; background: #faf5ff; }
.role-option.active { border-color: #a142f4; background: #faf5ff; box-shadow: 0 2px 8px rgba(161, 66, 244, 0.12); }
.role-option input[type="radio"] { display: none; }
.ro-icon { font-size: 22px; flex-shrink: 0; }
.ro-info { flex: 1; min-width: 0; }
.ro-info strong {
  display: block; font-size: 13px; color: #1e293b;
  font-weight: 700; text-transform: none; letter-spacing: 0;
}
.ro-info small {
  font-size: 10px; color: #94a3b8;
  font-weight: 500; text-transform: none; letter-spacing: 0;
  white-space: nowrap; overflow: hidden; text-overflow: ellipsis; display: block;
}
.role-option.active .ro-info strong { color: #a142f4; }

.set-badge.bonus-badge {
  background: #fef3c7;
  color: #b45309;
}

.salary-summary {
  background: linear-gradient(135deg, #faf5ff 0%, #f0e6ff 100%);
  border: 1px solid #e9d5ff;
  border-radius: 12px;
  padding: 12px 16px;
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.summary-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 13px;
  color: #475569;
}

.summary-item .summary-label {
  font-weight: 600;
}

.summary-item strong {
  color: #1e293b;
  font-weight: 800;
  font-family: 'Inter', system-ui, sans-serif;
}

/* V-SELECT */
::v-deep .modern-vselect .vs__dropdown-toggle {
  background: #f8fafc;
  border: 1px solid #f8fafc;
  border-radius: 12px;
  padding: 6px;
}

::v-deep .modern-vselect.vs--open .vs__dropdown-toggle {
  background: white;
  border-color: #a142f4;
}

/* BARCHASINI BELGILASH TUGMASI */
.btn-select-all {
  margin-left: auto;
  background: #f0e6ff;
  color: #a142f4;
  border: none;
  padding: 6px 16px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 13px;
  cursor: pointer;
  transition: 0.3s;
}

.btn-select-all:hover {
  background: #a142f4;
  color: white;
}

/* HUQUQLAR JADVALI */
.rules-table-wrapper {
  max-height: 50vh;
  overflow-y: auto;
  border-radius: 12px;
  border: 1px solid #f1f2f6;
}

.rules-table {
  width: 100%;
  border-collapse: collapse;
}

.rules-table thead {
  position: sticky;
  top: 0;
  z-index: 1;
}

.rules-table thead th {
  background: #f8fafc;
  padding: 12px 15px;
  font-size: 12px;
  font-weight: 700;
  color: #95a5a6;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-bottom: 1px solid #f1f2f6;
}

.th-center, .td-center {
  text-align: center;
  width: 80px;
}

.rules-table tbody td {
  padding: 10px 15px;
  font-size: 14px;
  color: #2c3e50;
  border-bottom: 1px solid #f8fafc;
}

.rules-table tbody tr:hover:not(.rule-group-header) {
  background: #faf8ff;
}

.rule-group-header td {
  background: #f0f2f5 !important;
  padding: 8px 15px !important;
  font-size: 12px;
  letter-spacing: 0.5px;
  color: #555;
}

.modern-checkbox {
  width: 18px;
  height: 18px;
  accent-color: #a142f4;
  cursor: pointer;
}

/* MOBIL ILOVA HUQUQLARI GRID */
.mobile-groups-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 14px;
}
.mobile-group-card {
  background: #faf8ff;
  border: 1px solid #f1e6ff;
  border-radius: 12px;
  padding: 14px 16px;
}
.mobile-group-title {
  display: flex;
  align-items: center;
  font-weight: 700;
  font-size: 14px;
  color: #2c3e50;
  padding-bottom: 8px;
  margin-bottom: 8px;
  border-bottom: 1px dashed #e0d4ff;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}
.mobile-perm-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.mobile-perm-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #2c3e50;
  padding: 4px 6px;
  border-radius: 8px;
  cursor: pointer;
  transition: 0.2s;
  margin: 0;
}
.mobile-perm-item:hover {
  background: white;
}
.mobile-perm-item input[type="checkbox"] {
  margin: 0;
}
.mt-4 { margin-top: 24px; }

.mt-3 { margin-top: 20px; }
.mb-4 { margin-bottom: 24px; }

@media (max-width: 768px) {
  .g-page {
    padding: 15px;
  }

  .modern-card {
    padding: 20px;
  }

  .section-divider {
    border-right: none;
    border-bottom: 1px solid #f1f2f6;
    padding-right: 0;
    margin-bottom: 30px;
    padding-bottom: 30px;
  }

  .header-row {
    flex-direction: column;
    gap: 15px;
    align-items: flex-start;
  }
}
</style>
